/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrgCapabilitiesExternalApproval { 
    /**
     * Is basic mode enabled.
     */
    basic_mode_enabled?: boolean;
    /**
     * Supported keys comma separated.
     */
    basic_mode_supported_keys?: string;
    /**
     * Is advanced mode enabled.
     */
    advanced_mode_enabled?: boolean;
    /**
     * Number of supported keys.
     */
    advanced_mode_supported_key_count?: string;
}

